<section class="section section--storeList">
  <div class="container">
    <div class="wrapper">
      <div class="content fadeinright animation-duration-300">
        <div class="content__main">

          <!-- ENCABEZADO APROBACIÓN -->
          <article class="mainInfo pb-30">
            <h1 class="pb-10">¡Tu crédito está aprobado!</h1>
            <div class="mainInfo__msg">
              <p>Elige una tienda y conoce el límite de tu crédito. Revisa las condiciones disponibles para usarlo.</p>
            </div>
          </article>

          <!-- ENCABEZADO PRE-APROBACIÓN -->
          <!-- <article class="mainInfo mainInfo--credit mb-25" *ngIf="preApprovalAmount() > 0">
            <div class="info">
              <h1 class="pb-2">¡Felicitaciones!</h1>
              <p>Tienes un crédito pre-aprobado de hasta:</p>
            </div>

            <div class="credit">
              <p>
                {{ currency }} <strong>{{ preApprovalAmount() }}</strong>
              </p>
            </div>
          </article> -->

          <!-- STICKY TRIGGER -->
          <div #stickyTrigger class="sticky-trigger"></div>

          <!-- SECCIÓN STICKY: FILTROS Y CATEGORÍAS -->
          <article class="storeList sticky-article pb-20" [ngClass]="{ 'border': isScrolled }">

            <!-- BUSCADOR Y BOTÓN DE FILTROS -->
            <div class="form storeList__filters pb-15">
              <div class="search">
                <div class="form__group">
                  <label class="form__label pb-10" for="search">Todas las tiendas afiliadas</label>

                  <div class="form__input p-input-icon-right">
                    <input
                      pInputText
                      type="text"
                      id="search"
                      [formControl]="searchControl"
                      placeholder="Buscar una tienda"
                    />
                    <i class="pi pi-search"></i>
                  </div>
                </div>
              </div>

              <div class="filter" (click)="onShowFilters()">
                <button
                  pButton
                  pRipple
                  icon="pi pi-sliders-h"
                  iconPos="left"
                  class="p-button-primary p-button-raised p-button-rounded"
                ></button>
                <!-- Badge con número de filtros activos -->
                <div class="filter__number" *ngIf="activeFiltersCount() > 0">
                  <span>{{ activeFiltersCount() }}</span>
                </div>
              </div>
            </div>

            <!-- CATEGORÍAS (DRAG SCROLL) -->
            <div class="storeList__categories pb-20">
              <div
                class="categoriesMenu"
                (mousedown)="onMouseDown($event)"
                (mousemove)="onMouseMove($event)"
                (mouseup)="onMouseUp()"
                (mouseleave)="onMouseUp()"
              >
                <div
                  class="categoriesMenu__item"
                  *ngFor="let category of allCategories()"
                  (click)="selectCategory(category.code)"
                  [ngClass]="{ active: selectedCategoryCode() === category.code }"
                >
                  <i [ngClass]="category.code">
                    <img [src]="category.icon_url" [alt]="category.name" />
                  </i>
                  <span>{{ category.name }}</span>
                </div>
              </div>
            </div>

            <!-- CONTADOR DE TIENDAS -->
            <div class="storeList__result">
              <p>Se han listado: <span>{{ totalStores() }} tiendas</span></p>
            </div>
          </article>

          <!-- LISTADO DE TIENDAS -->
          <article class="storeList" #storeListContainer>

            <!-- ESTADO: ERROR -->
            <div class="storeList__empty" *ngIf="componentState() === 'error'">
              <div class="empty-container">
                <i class="pi pi-exclamation-circle" style="font-size: 3rem; color: var(--red-500);"></i>
                <p class="mt-15">No pudimos cargar las tiendas.</p>
                <button
                  pButton
                  pRipple
                  label="Reintentar"
                  icon="pi pi-refresh"
                  iconPos="left"
                  class="p-button-primary p-button-raised p-button-rounded mt-15"
                  (click)="loadInitialData()"
                ></button>
              </div>
            </div>

            <!-- ESTADO: SIN RESULTADOS -->
            <div class="storeList__empty" *ngIf="componentState() === 'empty'">
              <div class="empty-container">
                <i class="pi pi-search" style="font-size: 3rem; color: var(--gray-400);"></i>
                <p class="mt-15">No encontramos tiendas para tu búsqueda.</p>
                <button
                  pButton
                  pRipple
                  label="Limpiar filtros"
                  icon="pi pi-filter-slash"
                  iconPos="left"
                  class="p-button-secondary p-button-raised p-button-rounded mt-15"
                  (click)="clearFilters()"
                ></button>
              </div>
            </div>

            <!-- ESTADO: TIENDAS CARGADAS -->
            <div class="storeList__items" *ngIf="componentState() === 'loaded'">
              <!-- GRID DE TIENDAS -->
              <div
                class="storeList__item"
                *ngFor="let store of displayedStores()"
                (click)="onSelectStore(store)"
              >
                <div class="storeCard">
                  <div class="storeCard__image">
                    <div class="image">
                      <!-- Con logo -->
                      <img
                        *ngIf="store.logo; else noImage"
                        [src]="store.logo"
                        [alt]="store.name"
                      />

                      <!-- Sin logo: mostrar icono genérico -->
                      <ng-template #noImage>
                        <div class="storeCard__imageDefault">
                          <app-store-icon color="color"></app-store-icon>
                        </div>
                      </ng-template>
                    </div>
                  </div>

                  <div class="storeCard__title">
                    <h3>{{ store.name }}</h3>
                  </div>
                </div>
              </div>
            </div>

            <!-- INDICADOR DE CARGANDO MÁS (Scroll Infinito) -->
            <div class="storeList__loadingMore pt-25" *ngIf="isLoadingMore()">
              <div class="loading-content loading-content--flex">
                <div class="loading-indicator">
                  <p-progressSpinner></p-progressSpinner>
                </div>
                <div class="loading-text"><span>Cargando más tiendas...</span></div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </div>
  </div>
</section>


<!-- ============================================================ -->
<!-- MODAL: DETALLE DE TIENDA -->
<!-- ============================================================ -->
<ng-container *ngIf="selectedStore()">
  <p-dialog
    [(visible)]="showStoreInfo"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
    position="bottom"
    (onHide)="closeStoreInfo()"
  >
    <div class="dialog__background" style="background-image: url('assets/images/backgrounds/background-store.jpg');"></div>

    <div class="dialog">
      <div class="container">
        <div class="wrapper">

          <!-- IMAGEN DE LA TIENDA -->
          <div class="dialog__image mb-15">
            <div class="storeList__imageRef">
              <div class="image">
                <!-- Con logo -->
                <img
                  *ngIf="selectedStore()?.logo; else noImageDialog"
                  [src]="selectedStore()?.logo"
                  [alt]="selectedStore()?.name"
                />

                <!-- Sin logo -->
                <ng-template #noImageDialog>
                  <div class="storeList__imageDefault">
                    <app-store-icon color="color"></app-store-icon>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>

          <!-- INFORMACIÓN DE LA TIENDA -->
          <div class="dialog__content">
            <div class="storeList__info">
              <h2 class="mb-10">{{ selectedStore()?.name }}</h2>
              <p *ngIf="selectedOffice()">
                <strong>La tienda más cercana a ti está en:</strong>
                <br />
                {{ selectedOffice()?.address }}
              </p>
            </div>

            <!-- DETALLES: MONTO Y ABONO -->
            <div class="storeList__details">
              <ul>
                <li>
                  <h3>Monto máximo:</h3>
                  <span>
                    {{ currency }} <strong>{{ preApprovalAmount() }}</strong>
                  </span>
                </li>

                <li>
                  <h3>Abono mínimo:</h3>
                  <span>
                    <strong>{{ selectedOffice()?.min_installment ?? 50 }}</strong>%
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <!-- BOTÓN CONFIRMAR -->
          <div class="dialog__footer">
            <button
              pButton
              pRippleF
              label="¡Lo quiero!"
              icon="pi pi-angle-right"
              iconPos="right"
              class="p-button-primary p-button-raised p-button-rounded p-button-spaced w-full" [loading]="isLoading"
              (click)="onConfirmStore()"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </p-dialog>
</ng-container>


<!-- ============================================================ -->
<!-- MODAL: FILTROS -->
<!-- ============================================================ -->
<p-dialog
  [(visible)]="showFilters"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  position="bottom"
>
  <div class="dialog dialog--filters">
    <form class="form" [formGroup]="form">
      <div class="container">
        <div class="wrapper">
          <div class="dialog__info pb-30">
            <h2>Filtrar tiendas</h2>
          </div>

          <div class="dialog__form">
            <div class="form__content">
              <!-- FILTRO: DISTANCIA -->
              <div class="form__group mb-25">
                <label class="form__label pb-5" for="distance">Distancia</label>

                <p-dropdown
                  [options]="distanceOptions"
                  formControlName="distance"
                  placeholder="Selecciona"
                  optionLabel="name"
                  [editable]="false"
                  id="distance"
                ></p-dropdown>
              </div>

              <!-- FILTRO: REGIÓN -->
              <div class="form__group">
                <label class="form__label pb-5" for="regions">Regiones</label>

                <p-dropdown
                  [options]="regionOptions"
                  formControlName="regions"
                  placeholder="Selecciona"
                  optionLabel="name"
                  [editable]="false"
                  id="regions"
                ></p-dropdown>
              </div>
            </div>

            <!-- BOTÓN LIMPIAR FILTROS -->
            <div class="form__btn form__btn--alignRight pt-10">
              <p-button
                label="Limpiar filtros"
                icon="pi pi-trash"
                iconPos="right"
                [text]="true"
                [plain]="true"
                class="blue"
                (click)="clearFilters()"
              ></p-button>
            </div>

            <!-- BOTÓN APLICAR FILTROS -->
            <div class="form__btn pt-30">
              <button
                pButton
                pRipple
                type="button"
                label="Filtrar"
                icon="pi pi-angle-right"
                iconPos="right"
                class="p-button-primary p-button-raised p-button-rounded p-button-spaced w-full"
                (click)="applyBackendFilters()"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</p-dialog>
